import React, { useCallback, useEffect, useState } from "react";
import { Image1, Image51, Image52, Image2, Image3, Logo } from "../../assets";
import "./ArchiveLanding2.scss";
import { useLocation } from "react-router-dom";
import {
  ArchFooter,
  MainNFTList,
  VerticalBar,
  FlexImage,
  Paragraph,
  ArchiveHeader,
  DiscoverArchiveSection,
} from "../../Components";
import { useAccess } from "../../context/AccessContext";

const CONTRACT_ADDRESS = "0xf679a38273547875b1730ae995a1b0d856868843".toLowerCase();

const ArchiveLanding2 = () => {
  const [loadingListings, setLoadingListings] = useState(true);
  const [listings, setListings] = useState([]);
  const location = useLocation();
  const selectedCollectionAddress =
    location.state?.address?.toLowerCase() || null;
  const AES_KEY = process.env.REACT_APP_AES_KEY;

  const { accessList, loading: accessLoading } = useAccess();

  const [isGateVerified, setIsGateVerified] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  const fetchFromSubgraph = useCallback(async () => {
    if (!selectedCollectionAddress) {
      setLoadingListings(false);
      return;
    }
    setLoadingListings(true);
    try {
    } catch (error) {
      console.error("Error fetching listings:", error);
      setListings([]);
    } finally {
      setLoadingListings(false);
    }
  }, [selectedCollectionAddress]);

  useEffect(() => {
    fetchFromSubgraph();
  }, [fetchFromSubgraph]);

  useEffect(() => {
    if (location.state?.verificationPassed) {
      setIsGateVerified(true);
    }

    if (!accessLoading) {
      const tokenMatch = accessList.includes(CONTRACT_ADDRESS);
      const hasMatchedTokensFromGate =
        location.state?.matchedTokens?.length > 0;

      setHasAccess(tokenMatch || hasMatchedTokensFromGate);

      if (tokenMatch || hasMatchedTokensFromGate) {
        setIsGateVerified(true);
      }
    }
  }, [accessList, accessLoading, location.state]);

  const images = [Image1, Image2, Image3];

  return (
    <div className="ArchiveLanding2">
      <DiscoverArchiveSection
        image={Image52}
        title="FUNOONI ARCHIVE"
        linkText="Archive"
      />
      <VerticalBar color="black" lineHeight="5px" />
      <FlexImage images={images} />
      <div className="paragraph3 paragraph4">
        <Paragraph style={{ whiteSpace: "pre-wrap" }}>
          {`
Our platform is a decentralized web service designed as a digital library and historical archive. It preserves photographs, documents, articles, journals, and other culturally significant materials in a secure, transparent, and permanent way. Built on modern blockchain technologies, the platform ensures that every piece of information stored within it remains authentic, tamper-proof, and accessible for generations. 

By combining decentralized architecture with a curated archival approach, the system offers both the reliability of traditional libraries and the resilience of distributed networks. Each historical record is stored with a verifiable digital footprint, making it possible to track provenance, confirm integrity, and protect data from corruption or unauthorized alteration.`}
        </Paragraph>
      </div>

      <ArchiveHeader
        topImage={Image52}
        mainImage={Image51}
        title="Palestine & Neighboring Countries"
        years="1840 - 1950"
        isGateVerified={isGateVerified}
      />
      <div className="paragraph3 paragraph5">
        <Paragraph maxWidth="90%">
          {`
A one of a kind decentralized digital archive preserving rare photographs, advertisements, documents, and social and political events from Palestine before 1948 Nakba. These collections offer a powerful glimpse into daily life, important figures, family heritage and overlooked stories before that era.

Curated by Funooni, each piece is carefully selected and preserved through cutting-edge blockchain technology, ensuring authenticity and permanence. From historic ads and forgotten documents to significant cultural and political moments, this archive safeguards Palestine’s visual and cultural memory for future generations.

More than just an archive, it’s a tribute to the past, and a living tool for education, storytelling, and heritage preservation in the digital age.
`}
        </Paragraph>
      </div>
      {!accessLoading && hasAccess && <MainNFTList aesKey={AES_KEY} />}

      <ArchFooter logoSrc={Logo} altText="Funooni Logo" />
    </div>
  );
};

export default ArchiveLanding2;
